export const handleGetMaxPage = (totalDataCount: number, pageLimit: number) => {
  return Math.ceil(totalDataCount / pageLimit);
};
